import { render, staticRenderFns } from "./ComplianceLayout.vue?vue&type=template&id=0b62dff8"
import script from "./ComplianceLayout.vue?vue&type=script&lang=js"
export * from "./ComplianceLayout.vue?vue&type=script&lang=js"
import style0 from "./ComplianceLayout.vue?vue&type=style&index=0&id=0b62dff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports